import {useEffect, useState} from "react";
import {findLevelRequirementsWithPagination} from "../api/levelApiClient";

export const useLevelRequirements = (levelId, page, pageSize, reloadTrigger) => {
    const [levelRequirements, setLevelRequirements] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const levelRequirementsWithPagination = findLevelRequirementsWithPagination(levelId, page, pageSize, abortController.signal);

        levelRequirementsWithPagination
            .then(
                (data) => {
                    const levelRequirements = data.levelRequirements;
                    const pagination = data.pagination;

                    setLevelRequirements(levelRequirements)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [levelId, page, pageSize, reloadTrigger]);

    return {levelRequirements : levelRequirements, pagination};
};